import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { fmtTRY } from "../../lib/format";
import { useStore } from "../../context/StoreContext";

export default function ProductCard({ product, index = 0 }) {
  const { addToCart } = useStore();
  const navigate = useNavigate();
  const image = product.images?.[0];
  const hasDiscount = product.display_price < product.list_price;

  const handleAdd = (e) => {
    e.preventDefault();
    if (product.has_variants) {
      navigate(`/urun/${product.slug}`);
    } else {
      addToCart(product.product_id, null, 1);
    }
  };

  return (
    <Link
      to={`/urun/${product.slug}`}
      className="group flex flex-col h-full bg-white rounded-2xl border border-[#E6E4DD] overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_20px_50px_-20px_rgba(18,18,20,0.25)] transition-all duration-300"
      data-testid={`product-card-${product.sku || product.product_id}`}
    >
      {/* Standart görsel alanı: tüm kartlarda aynı ölçü — kare alan + contain (img absolute: intrinsic boyut kutuyu şişiremez) */}
      <div className="relative aspect-square overflow-hidden bg-[#F4F2EB]">
        {image && (
          <img src={image} alt={product.name} loading="lazy"
            className="absolute inset-0 w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-700 ease-out" />
        )}
        <div className="absolute top-3 left-3 flex flex-col gap-1.5">
          {hasDiscount && (
            <span className="bg-rose-600 text-white text-[11px] font-bold px-2.5 py-1 rounded-full" data-testid="product-discount-badge">
              %{product.discount_percent} İndirim
            </span>
          )}
          {product.is_new && <span className="bg-[#121214] text-white text-[11px] font-semibold px-2.5 py-1 rounded-full">Yeni</span>}
        </div>
        {product.requires_quote ? (
          <span className="absolute bottom-3 right-3 bg-[#121214] text-white text-[11px] font-semibold px-3 py-1.5 rounded-full" data-testid="product-quote-badge">
            Teklif Al
          </span>
        ) : (
        <>
        {product.total_stock <= 0 ? (
          <span className="absolute bottom-3 left-3 bg-neutral-900/80 text-white text-[11px] px-2.5 py-1 rounded-full">TÜKENDİ</span>
        ) : product.total_stock <= (product.critical_stock || 5) ? (
          <span className="absolute bottom-3 left-3 bg-amber-500/95 text-white text-[11px] font-semibold px-2.5 py-1 rounded-full animate-pulse-soft">
            Son {product.total_stock} adet
          </span>
        ) : null}
        <button
          onClick={handleAdd}
          disabled={product.total_stock <= 0}
          className="absolute bottom-3 right-3 h-10 w-10 rounded-full bg-[#121214] text-white flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 hover:bg-amber-600 disabled:opacity-40"
          data-testid={`product-card-add-btn-${product.sku || product.product_id}`}
          aria-label="Sepete ekle"
        >
          <ShoppingBag size={16} />
        </button>
        </>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        {/* Sabit yükseklikli satırlar: marka/kampanya olsa da olmasa da kart hizası bozulmaz */}
        <p className="font-mono-ed text-[10px] uppercase tracking-[0.2em] text-neutral-400 mb-1 min-h-[13px]">{product.brand_name || ""}</p>
        <h3 className="font-semibold text-sm leading-snug line-clamp-2 min-h-[2.5rem]" data-testid="product-card-title">{product.name}</h3>
        <p className={`text-[11px] font-medium mt-1 min-h-[15px] ${product.campaign_name ? "text-amber-700" : ""}`}>{product.campaign_name || ""}</p>
        {product.requires_quote ? (
          <p className="text-sm font-semibold text-amber-700 mt-auto pt-2" data-testid="product-card-quote-label">Fiyat için teklif alın</p>
        ) : (
        <div className="flex items-baseline gap-2 mt-auto pt-2" data-testid="product-card-price">
          <span className="font-mono-ed font-bold text-base">{fmtTRY(product.display_price)}</span>
          {hasDiscount && <span className="text-xs text-neutral-400 line-through">{fmtTRY(product.list_price)}</span>}
        </div>
        )}
      </div>
    </Link>
  );
}
